export default __webpack_public_path__ + "static/media/mettmann_signet.d55700dc.png";